import {
  PhoneConfirmationFormValues,
  PhoneConfirmationFormViolation,
} from 'types/phoneConfirmationFormTypes';
import { parsePhoneNumber } from 'libphonenumber-js';

const PHONE_CODE_LENGTH = 6;

export const createPhoneConfirmationFormValues = (): PhoneConfirmationFormValues => ({
  phone: '',
  code: Array(PHONE_CODE_LENGTH).fill(''),
});

export const validatePhoneConfirmationFormValues = (
  values: PhoneConfirmationFormValues
): PhoneConfirmationFormViolation[] => {
  const violations: PhoneConfirmationFormViolation[] = [];

  const { phone } = values;

  if (!phone) {
    violations.push({ name: 'PhoneInvalid' });
    return violations;
  }

  let phoneNumber;

  try {
    phoneNumber = parsePhoneNumber(phone);
  } catch {
    phoneNumber = null;
  }

  if (!phoneNumber || !phoneNumber.isValid()) {
    violations.push({ name: 'PhoneInvalid' });
  }

  return violations;
};

export const validatePhoneConfirmationCodeFormValues = (
  values: PhoneConfirmationFormValues
): PhoneConfirmationFormViolation[] => {
  const violations: PhoneConfirmationFormViolation[] = [];

  const { code } = values;

  for (let digitIndex = 0; digitIndex < code.length; digitIndex++) {
    const digitValue = code[digitIndex];
    if (digitValue === '') {
      violations.push({
        name: 'DigitMissed',
        digitIndex,
      });
    }
  }

  return violations;
};
